(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/lyckoplatsen/shared/prolong-bottom-sheet.js') >= 0) return;  svs.modules.push('/components/tur/lyckoplatsen/shared/prolong-bottom-sheet.js');

'use strict';

const {
  useState,
  useEffect
} = React;
const {
  ReactBottomSheet: {
    BottomSheet
  }
} = svs.ui;
const {
  RadioGroup,
  RadioButton
} = svs.ui.reactForm;
const {
  ReactButton: Button,
  ReactDots: Dots
} = svs.ui;
const svsUtilsformatCurrency = svs.utils.format.Currency;
const {
  makePayment,
  drawDateText,
  drawDateTextAsync,
  setupSubscription
} = svs.tur.pay_lyckoplatsen;
const {
  showProlongedGeoDialog,
  showAlreadyProlongedDialogAsync
} = svs.tur.lyckoplatsen.shared;
const getAccountBalanceAsync = () => new Promise(resolve => {
  svs.components.account_balance.get(true, balance => {
    resolve(balance);
  });
});
const ProlongBottomSheet = _ref => {
  var _wager$wagerCharity;
  let {
    charityName,
    onCloseBottomSheet,
    onProlongSuccessCallback,
    wager
  } = _ref;
  const [accountBalance, setAccountBalance] = useState(null);
  const [dateText, setDateText] = useState('');
  const [numberOfWeeks, setNumberOfWeeks] = useState(4);
  const nameOfCharity = ((_wager$wagerCharity = wager.wagerCharity) === null || _wager$wagerCharity === void 0 ? void 0 : _wager$wagerCharity.name) || charityName;
  const isSubscription = numberOfWeeks === 0;
  let payButtonText = 'Betala 160 kr (40 kr/vecka)';
  if (isSubscription) {
    payButtonText = 'Prenumerera (40 kr/vecka)';
  }
  const radioButtons = [{
    value: 4,
    text: 'Spela 4 veckor'
  }, {
    value: 0,
    text: 'Prenumerera'
  }];
  useEffect(() => {
    (async () => {
      const balance = await getAccountBalanceAsync();
      setAccountBalance(svsUtilsformatCurrency(balance));
    })();
  }, []);
  useEffect(() => {
    (async () => {
      let text;
      if (isSubscription) {
        text = drawDateText({
          isSubscription: true
        });
      } else {
        text = await drawDateTextAsync({
          numberOfWeeks
        });
      }
      setDateText(text);
    })();
  }, [isSubscription, numberOfWeeks]);
  const handlePayFinished = _ref2 => {
    let {
      wagerId
    } = _ref2;
    const charityObject = wager.wagerCharity ? wager.wagerCharity : {
      charityId: wager.wager.bets[0].geoBoardData.charityId,
      name: charityName,
      status: charityName ? 1 : 2
    };  
    showProlongedGeoDialog({
      charity: charityObject,
      wagerId
    });
    svs.components.Storage.browser.set(wager.wagerId, 'geogameProlong', true, svs.components.Storage.constants.EXPIRES_1H);
    onCloseBottomSheet();
    onProlongSuccessCallback === null || onProlongSuccessCallback === void 0 || onProlongSuccessCallback();
  };
  const handlePayClick = async _ref3 => {
    var _wager$wagerCharity2;
    let {
      isAfterDeposit = false
    } = _ref3;
    if (svs.components.Storage.browser.get(wager.wagerId, 'geogameProlong') && !isAfterDeposit) {
      const stillWantToProlong = await showAlreadyProlongedDialogAsync(isSubscription);
      if (!stillWantToProlong) {
        onCloseBottomSheet();
        return;
      }
    }
    const data = {
      charityId: ((_wager$wagerCharity2 = wager.wagerCharity) === null || _wager$wagerCharity2 === void 0 ? void 0 : _wager$wagerCharity2.charityId) || wager.wager.bets[0].geoBoardData.charityId,
      numberOfWeeks,
      product: 'Lyckoplatsen',
      pinLocation: {
        lat: wager.wager.bets[0].geoBoardData.geoLoc.latitude.replace(',', '.'),
        lng: wager.wager.bets[0].geoBoardData.geoLoc.longitude.replace(',', '.')
      },
      lyckoplatsenName: wager.description,
      pinLocationType: wager.wager.bets[0].geoBoardData.geoLocType,
      isProlongination: true,
      prolongOriginalWager: wager,
      isAfterDeposit,
      lastDrawDate: wager.lastDrawDate
    };
    if (isSubscription) {
      const callback = () => {
        const cancelUrl = encodeURIComponent(svs.utils.url.makeInternal(location.href, svs.core.urlMapping.get('lyckoplatsenHome')));
        const subscriptionPayUrl = "".concat(svs.core.urlMapping.get('subscriptionStart'), "?cancelUrl=").concat(cancelUrl, "&product=lyckoplatsen");
        svs.utils.url.navigate(subscriptionPayUrl);
      };
      setupSubscription({
        data,
        callback
      });
    } else {
      svs.utils.paramHandler.set({
        key: 'prolong',
        value: wager.wagerId
      });
      makePayment({
        data,
        onDone: handlePayFinished
      });
    }
  };
  const handleRadioGroupChange = value => {
    setNumberOfWeeks(value);
  };
  const editProlongWager = e => {
    e.preventDefault();
    svs.tur.lyckoplatsen.utils.clearWagerStorageAndNavigateToProlong({
      wagerId: wager.wagerId
    });
  };
  useEffect(() => {
    if (svs.core.detect.feature('ft-lyckoplatsen-pay-after-deposit') && svs.utils.paramHandler.get({
      key: 'afterpay'
    }).value) {
      handlePayClick({
        isAfterDeposit: true
      });
      svs.utils.paramHandler.remove({
        key: 'afterpay'
      });
    }
  }, []);
  return React.createElement(BottomSheet, {
    behavior: "modal",
    className: "lp-prolong-bottom-sheet",
    headerTitle: "F\xF6rl\xE4ng spel",
    isFixed: true,
    onStateChange: newState => {
      if (newState.state === 'closed') {
        onCloseBottomSheet();
      }
    }
  }, React.createElement("div", null, React.createElement("div", {
    className: "padding-xs-h-1 padding-md-h-2 f-content"
  }, React.createElement("div", {
    className: "padding-v-1 bold"
  }, wager.description), React.createElement(RadioGroup, {
    size: 200
  }, radioButtons.map(_ref4 => {
    let {
      value,
      text
    } = _ref4;
    return React.createElement(RadioButton, {
      checked: numberOfWeeks === value,
      key: value,
      name: "toggle-choice",
      onChange: () => handleRadioGroupChange(value),
      value: value
    }, text);
  })), React.createElement("div", {
    className: "margin-bottom u-text-center padding-top padding-bottom"
  }, dateText), nameOfCharity && React.createElement("div", {
    className: "margin-bottom-1 padding-v"
  }, "Bidrar till: ".concat(nameOfCharity)))), React.createElement(Dots, {
    branding: "tur",
    className: "padding-bottom-2 margin-top"
  }, React.createElement("div", {
    className: "margin-xs-h-1 margin-md-h-2 padding-top"
  }, accountBalance && React.createElement("p", null, "Ditt saldo: ".concat(accountBalance, " kr")), React.createElement(Button, {
    block: true,
    focus: true,
    onClick: handlePayClick
  }, payButtonText), React.createElement("div", {
    className: "u-text-center margin-top-1"
  }, React.createElement("a", {
    href: "/lyckoplatsen/forlang-mina-spel/".concat(wager.wagerId),
    onClick: editProlongWager
  }, React.createElement("span", {
    className: "fc-navy u-text-decoration-underline f-medium"
  }, "\xC4ndra"))))));
};
setGlobal('svs.tur.lyckoplatsen.shared', {
  ProlongBottomSheet
});

 })(window);